<template>
    <div class="cnoilBanner">
        <div class="video-box">
            <video 
                ref="video" 
                :src="bannerText.ExtString1" 
                muted 
                v-if="bannerText.ExtString1"  
                preload="auto" 
                loop
                autoplay
                x5-video-player-type="h5"
                webkit-playsinline
                playsinline
                :poster="bannerText.Pic"
                @playing='onplaying'
            ></video>
            <Icon type="ios-play-outline" class="playIcon" size="50" color="#fff" @click="videoPlay" v-if="this.isWx && bannerText.ExtString1" />
            <img :src="bannerText.Pic" v-if="!bannerText.ExtString1"/>
            <Button type="primary" ghost class="bannerButton" @click="goToArticle" v-if="!(type == 'detail' && !bannerText.ExtString1)" size="large">{{bannerText.Flag2}}</Button>
        </div>

        <!-- 视频弹窗 -->
        <Modal v-model="modal" :footer-hide="true" closable @on-cancel="false" width='800'>
          <div slot="header">
            <span>{{bannerText.Title}}</span>
          </div>
          <div :style="{ height: isWideScreen ? '500px' : '300px' }">
            <Video class="modalVideo" :src='bannerText.ExtString2' :seekable='true' :pic='bannerText.Pic' :style="{ height: isWideScreen ? '500px' : '300px' }" v-if="modal"/>
          </div>
        </Modal>
    </div>
</template>

<script>
import Video from '@/components/common/Video'
import {
    mapActions
} from 'vuex'
export default ({
    data() {
        return {
            // 屏幕宽度
            screenWidth: window.innerWidth,
            modal: false,
            isWx: false
        }
    },
    props:{
        bannerText: {
            type: Object,
            default: ()=>{},
        },
        type: {
            type: String,
            default: 'index'
        }
    },
    components: {
        Video
    },
    watch: {
        bannerText: {
            handler() {
                this.initData();
            },
            deep: true
        }
    },
	computed: {
        isWideScreen() {  
            return this.screenWidth >= 768;  
        }  
	},
	created() {
        this.$nextTick(function() {
			this.initData()
		})
	},
    mounted() {
        this.$nextTick(() => {
            this.videoPlay()
	    })
    },
    methods: {
        ...mapActions([
            'recordBrowsingAction'
        ]),
        initData() {
            let ua = navigator.userAgent.toLowerCase()
            this.isWx = ua.indexOf('micromessenger') != -1
        },
        // banner点击按钮
        goToArticle() {
            this.modal = true
        },
        // 判断屏幕宽度
        handleResize() {
            this.screenWidth = window.innerWidth; 
        },
        videoPlay() {
		    const videoElement = this.$refs.video;
            videoElement.play()
        },
        onplaying() {
            this.isWx = false

        }
    }
})


</script>

<style lang="scss" scoped>
@import "@/style/mixin";
@import "@/style/common";

.cnoilBanner {
    position: relative;
    .video-box {
        overflow: hidden;
        img,video {
            width: 100%;
            display: block;
            object-fit: cover
        }
        .playIcon {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -25px;
            margin-left: -25px
        }
    }
    .bannerText {
        position: absolute;
        bottom: 30%;
        left: 50%;
        transform: translate(-50%, 0);
        color: #fff;
        font-size: 0.8rem;
        font-weight: 600;
    }
    .bannerButton {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translate(-50%, 0);
        display: flex;
        justify-content: center;
        align-items: center;
        @include fontSize($font-size-20);
        padding: 0 30px;
        color: #fff;
        border-color: #fff;
        background-color: rgba(0, 0, 0, 0.2)
    }
    .bannerButton:hover {
        background-color: rgba(0, 0, 0, 0.4)
    }
    .video {
        width: 100%;
    }
    .modalVideo {
        width: 100%;
        margin-top: 10px !important;
    }
}
@media (max-width: 768px) {
    .cnoilBanner {
        .bannerText {
            white-space: nowrap;
            overflow: hidden;
            font-size: 10vw !important;
        }
    }
}

</style>
